import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Login } from './Login';
import stepsActions from 'actions/stepsActions';

const ConnectedLoginContainer = props => {
    return <Login {...props} />;
};

const mapStateToProps = state => ({
    options: state.options,
});

const mapDispatchToProps = dispatch => ({
    stepsActions: bindActionCreators(stepsActions, dispatch),
});

export const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(ConnectedLoginContainer);
